/** Shopify CDN: Minification failed

Line 31:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 32:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 32:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 34:49 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 35:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 39:20 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 21:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 22:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 22:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 24:49 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 25:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 29:20 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 11:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 12:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 12:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 14:49 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 15:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 19:20 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
(async () => {
    const { Core } = await importModule('Core');

    customElements.define('collection-nav-item', class extends Core {
        render() {
            this.addEventListener('click', this._handleClick.bind(this));
        }

        _handleClick(e) {
            e.preventDefault();
            this.publish('navigation:change', {
                url: this.getAttribute('to')
            })
        }
    })
})();
